import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Table, Button, Input, Row, Col, Spin, Form } from "antd"
import PersianDatePickerRange from "components/Common/PersianDatePickerRange"
import { getEngLeaves, upsertEngLeave, deleteEngLeave } from "store/actions"
import { columnsGrid } from "./columns.js"
import { getCurrentUser } from "helpers/service_helper"

const EngLeave = props => {
  const { lstEngLeaves, loading } = props
  const [pageSize, setPageSize] = useState(8)
  const [editingRow, setEditingRow] = useState(null)
  const [formState, setFormState] = useState({
    solarFromDate: "",
    solarToDate: "",
    inactiveDes: "",
  })
  const [range, setRange] = useState({ from: null, to: null })
  const [pickerKey, setPickerKey] = useState(0)
  const [editForm] = Form.useForm()

  const clearPicker = () => {
    // clear parent's stored range and form values for dates, and force remount of the picker
    setRange({ from: null, to: null })
    setFormState({ solarFromDate: "", solarToDate: "", inactiveDes: "" })
    setPickerKey(k => k + 1)
  }

  useEffect(() => {
    props.onGetEngLeaves(getCurrentUser().sid)
  }, [])

  useEffect(() => {
    if (editingRow) {
      editForm.setFieldsValue({
        solarFromDate: editingRow.solarFromDate || "",
        solarToDate: editingRow.solarToDate || "",
        inactiveDes: editingRow.inactiveDes || "",
      })
    } else {
      editForm.resetFields()
      // also clear local formState and the date picker
      clearPicker()
    }
  }, [editingRow])

  const handleEdit = row => {
    setEditingRow(row)
    editForm.setFieldsValue({
      solarFromDate: row.solarFromDate || "",
      solarToDate: row.solarToDate || "",
      inactiveDes: row.inactiveDes || "",
    })
  }
  const handleDelete = id => {
    props.onDeleteEngLeave(id)
  }

  const handleCreateSave = async () => {
    const payload = {
      engId: getCurrentUser().sid,
      id: undefined,
      solarFromDate: formState.solarFromDate,
      solarToDate: formState.solarToDate,
      inactive: true,
      inactiveDes: formState.inactiveDes,
    }
    await props.onUpsertEngLeave(payload)
    setFormState({ solarFromDate: "", solarToDate: "", inactiveDes: "" })

    props.onGetEngLeaves()
  }

  const handleCancel = () => {
    setEditingRow(null)
    editForm.resetFields()
    clearPicker()
  }

  const handleSave = async id => {
    try {
      const values = await editForm.validateFields()
      const payload = {
        EngId: getCurrentUser().sid,
        id: id,
        solarFromDate: values.solarFromDate,
        solarToDate: values.solarToDate,
        inactive: false,
        inactiveDes: values.inactiveDes,
      }
      await props.onUpsertEngLeave(payload)
      setEditingRow(null)
      editForm.resetFields()
      clearPicker()
      props.onGetEngLeaves(getCurrentUser().sid)
    } catch (e) {
      // validation failed
    }
  }

  return (
    <>
      <Row gutter={[16, 16]}>

        <Col xs={24}>
          <h5>ثبت مرخصی</h5>
        </Col>
        <Col xs={24} sm={12}>
          <PersianDatePickerRange
            key={pickerKey}
            setRange={r => {
              setRange(r)
              setFormState({
                ...formState,
                solarFromDate: r.from ? r.from.persian : "",
                solarToDate: r.to ? r.to.persian : "",
              })
            }}
            defaultFrom={formState.solarFromDate}
            defaultTo={formState.solarToDate}
            labelFrom={props.t("fromDate")}
            labelTo={props.t("toDate")}
          />
        </Col>
        <Col xs={24} sm={12}>
          <Input.TextArea
            rows={3}
            placeholder={"توضیحات"}
            value={formState.inactiveDes}
            onChange={e =>
              setFormState({ ...formState, inactiveDes: e.target.value })
            }
          />
        </Col>

        <Col xs={24}>
          {loading ? (
            <Spin />
          ) : (
            <Button type="primary" onClick={handleCreateSave}>ذخیره </Button>
          )}
        </Col>

        <Col xs={24}>
          <Form form={editForm} component={false}>
            <Table
              dataSource={lstEngLeaves || []}
              columns={columnsGrid({
                onDelete: handleDelete,
                onEdit: handleEdit,
                isEditing: record => editingRow && editingRow.id === record.id,
                save: handleSave,
                cancel: handleCancel,
                t: props.t,
                editForm,
              })}
              rowKey={record => record.id}
              pagination={{ pageSize }}
              loading={loading}
            />
          </Form>
        </Col>



      </Row>
    </>
  )
}

const mapStateToProps = ({ Engineers }) => ({
  lstEngLeaves: Engineers.lstEngLeaves,
  loading: Engineers.loading,
  error: Engineers.error,
  success: Engineers.success,
})

const mapDispatchToProps = dispatch => ({
  onGetEngLeaves: () => dispatch(getEngLeaves()),
  onUpsertEngLeave: data => dispatch(upsertEngLeave(data)),
  onDeleteEngLeave: id => dispatch(deleteEngLeave(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EngLeave))
